import axios from "axios";
import { store } from "store/store";
import appConfig from "../../config";
import errorResponseHandler from "./errorHandler";
import successResponseHandler from "./successHandler";

export const NetworkConfig = () => {
  axios.defaults.baseURL = appConfig.baseUrl;
  axios.defaults.timeout = 30000;
  axios.defaults.headers.get["Accept"] = "application/json";
  axios.defaults.headers.post["Accept"] = "application/json";

  axios.interceptors.request.use(async (config) => {
    const { token, actingOrganizationId, admin } = store.getState().auth;
    if (token) {
      config.headers.Authorization = token;
    } else {
      delete config.headers.Authorization;
    }
    // Only platform admins can act in another organization; for everyone else
    // the server ignores the header.
    if (actingOrganizationId && admin?.is_platform_admin && !config.headers["X-Organization-Id"]) {
      config.headers["X-Organization-Id"] = actingOrganizationId;
    }
    return config;
  });
  axios.interceptors.response.use(successResponseHandler, errorResponseHandler);
};
